'use client';
import { useEffect, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setCampaignWinnerModal } from '@/slices/popSlice';
import useCountDown from '@/hook/useCountDown';
import dayjs from 'dayjs';

const CampaignCountdown = ({ drawTime, endTime }) => {
    const dispatch = useDispatch();
    const [{ second }, countDown] = useCountDown();
    const [endDayDrawTime, setEndDayDrawTime] = useState(null); // 活動結束日的抽獎時間

    // 處理倒數時間
    const handleCountdown = (targetHour, targetMinute) => {
        const targetTime = dayjs().hour(targetHour).minute(targetMinute).second(0);
        const currentTime = dayjs();

        // 如果現在的時間已經超過 targetTime，則將 targetTime 加一天
        if (currentTime.isAfter(targetTime)) targetTime.add(1, 'day');

        // 計算時間差 => 倒數
        const differenceInSeconds = targetTime.diff(currentTime, 'seconds');
        countDown(differenceInSeconds);
    };

    // 先判斷活動結束日當天的開獎時間 再看要不要倒數
    const handleEndDayDrawTime = () => {
        const [targetHour, targetMinute] = drawTime.split(':').map(Number);
        const endMoment = dayjs(endTime, 'YYYY-MM-DD HH:mm:ss').set({
            hour: targetHour,
            minute: targetMinute,
            second: 0,
        });

        setEndDayDrawTime(endMoment);

        if (!isNaN(targetHour) && !isNaN(targetMinute) && dayjs().isBefore(endMoment)) {
            // 確認目標時間在 endTime 之前
            if (dayjs().isBefore(endMoment)) {
                handleCountdown(targetHour, targetMinute);
            }
        }
    };

    // 格式化數字，確保兩位數顯示
    const formatTime = (time) => (time < 10 ? `0${time}` : time);

    // 計算時間部分
    const timeDisplay = useMemo(() => {
        const hours = formatTime(Math.floor(second / 3600));
        const minutes = formatTime(Math.floor((second % 3600) / 60));
        const seconds = formatTime(second % 60);

        return { hours, minutes, seconds };
    }, [second]);

    // 判斷活動是否結束
    const isCampaignOver = useMemo(() => {
        const now = dayjs();
        const campaignState =
            now.isAfter(endDayDrawTime) ||
            now.isAfter(endTime) ||
            dayjs(endDayDrawTime).isAfter(endTime);

        return campaignState;
    }, [endDayDrawTime, endTime]);

    useEffect(() => {
        if (drawTime && endTime) handleEndDayDrawTime();
    }, [drawTime, endTime]);

    return (
        <div
            className="mt-[32px] mb-[27px] mx-auto space-y-[13px] text-center
        ulg:mt-[30px] ulg:mb-[40px]"
        >
            {isCampaignOver ? (
                // 超過活動結束日的開獎時間
                <p className="text-h2 text-[#fff]">活動已結束</p>
            ) : (
                <>
                    <p className="text-white text-btn2">今日開獎倒數</p>
                    <div
                        className="center-center gap-x-[18px] text-white [&>span]:text-h4 [&>div]:space-y-[3px] [&>div>p]:text-h2 [&>div]:w-[65px]
                        [&_span]:relative [&_span]:bottom-[5px] [&_p]:tabular-nums uxs:gap-x-[9px]"
                    >
                        <div>
                            <p>{timeDisplay.hours || '00'}</p>
                            <p className="!text-bd3n">HOURS</p>
                        </div>

                        <span>：</span>

                        <div>
                            <p>{timeDisplay.minutes || '00'}</p>
                            <p className="!text-bd3n">MINUTES</p>
                        </div>

                        <span>：</span>

                        <div>
                            <p>{timeDisplay.seconds || '00'}</p>
                            <p className="!text-bd3n">SECONDS</p>
                        </div>
                    </div>
                </>
            )}

            <button
                onClick={() => dispatch(setCampaignWinnerModal(true))}
                className="hidden !mt-[40px] w-[95%] max-w-[277px] ulg:block mx-auto text-btn1 text-[#f7f7f8] text-center rounded-[8px] border-1
            border-[#fff] border-opacity-[.2] bg-[#006F8b] backdrop-blur-[10px] py-[16px]"
            >
                查看中獎名單
            </button>
        </div>
    );
};

export default CampaignCountdown;
